import {assignSoft} from "../utils";

export default function (widget) {
    const µ = widget.µ;

    const widgetContainer = {

        // controller: function () {
        //   const ctrl = {};
        //   return ctrl;
        // },

        view: function (ctrl, props) {
            const children = [].slice.call(arguments, 2);
            assignSoft(props, {
                tabIndex: 0,
                unselectable: 'on',
            });
            return µ('div', props, children);
        },
    };

    return widgetContainer;

}
